import React from "react";
import PropTypes from "prop-types";
import { Link, useParams } from "react-router-dom";
import { Button } from "rhombus-react";

const DEFAULT_LABEL = "Add New Bulk Sheet";
const DEFAULT_BUTTON_STYLE = "block";

export default function AddContentFeedButton({ label = DEFAULT_LABEL, buttonStyle = DEFAULT_BUTTON_STYLE }) {
	const { libraryId } = useParams();

	return (
		<Link to={`/library/${libraryId}/content-feeds/new`}>
			<Button icon="fas fa-plus-circle" theme="blue" style={buttonStyle}>
				{label}
			</Button>
		</Link>
	);
}

AddContentFeedButton.displayName = "AddContentFeedButton";

AddContentFeedButton.propTypes = {
	label: PropTypes.string,
	buttonStyle: PropTypes.string,
};
